<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import { TrackOrders } from '@/api'
import Dropdown from '@/components/atoms/Dropdown'
import InputSelect from '@/components/atoms/inputlib/components/InputSelect'

const trackOrders = Vue.observable(new TrackOrders())

export default {
    name: 'TrackingAlert',
    components: { InputSelect, Dropdown },
    data() {
        return {
            close: false,
            order: null,
        }
    },

    computed: {
        trackOrders: () => trackOrders,
        ...mapGetters(['lgDevice', 'smDevice']),
        list() {
            return this.trackOrders?.items || []
        },
    },

    async mounted() {
        if (this.$user._isLoggedIn) {
            await this.trackOrders.fetch({ limit: 100 })
            this.order = this.list[0]
        }
    },

    methods: {
        closeAlert() {
            this.close = true
        },
    },
}
</script>

<template lang="pug">
    transition(name="fade")
        router-link.tracking-alert.alert-wrapper(
            v-if="$user.isLoggedIn && order && !close" tag="div"
            role="button"
            :to="{name: 'summary-page', params: {id: order.id}}")
            .alert.alert-primary.d-flex
                .d-flex.align-items-center.flex-wrap
                    img.mr-4.mr-lg-4(src="/images/marker-courier.svg" loading="lazy")
                    span.line-1 {{$t('alerts.tracking')}}
                    input-select(
                        v-model="order"
                        :custom-label="order => `#${order.identifier} - ${order.restaurantName}`"
                        track-by="id"
                        :disabled="!(list.length > 1)"
                        @click.stop.prevent.native
                        :options="list"
                        :clearable="false"
                        no-empty small)
                    .btn.btn-xs.text-white
                        icon(icon="fa-solid fa-share")
                button.btn.btn-link.link-white.ml-auto(@click.stop="closeAlert")
                    icon(icon="fa-solid fa-times")
</template>
